import React, { FC, useMemo } from 'react';

import Star from 'material-react-icons/Star';
import StarBorder from 'material-react-icons/StarBorder';
import StarHalf from 'material-react-icons/StarHalf';

import useTranslate from '../../hooks/useTranslate';
import getGolfClubInfo from '../../services/apis/golfCourses/getGolfClubInfo';
import { MappedGolfCourseType } from '../../services/apis/golfCourses/types';

interface RatingBoxProps {
  course: MappedGolfCourseType;
}

const RatingBox: FC<RatingBoxProps> = ({ course }) => {
  const { translate } = useTranslate();
  const golfCourseInfo = useMemo(() => getGolfClubInfo(course), [course]);
  const isGolfhaftet = !!golfCourseInfo?.golfhaftetRating;
  const ratingToUse = golfCourseInfo?.golfhaftetRating || golfCourseInfo?.googleRating;

  if (!ratingToUse) {
    return null;
  }

  // Round to nearest 0.5
  const rating = Math.round(ratingToUse.rating * 2) / 2;
  const wholeStars = Math.floor(rating);
  const halfStar = rating - wholeStars > 0.3;
  const emptyStars = 5 - wholeStars - (halfStar ? 1 : 0);
  return (
    <div className="mb-3">
      <span id={`rating${course.id}`}>
        {[...Array(wholeStars)].map((_, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Star key={i} color="#7CA324" size={20} />
        ))}
        {halfStar && <StarHalf color="#7CA324" size={20} />}
        {emptyStars > 0 &&
          // eslint-disable-next-line react/no-array-index-key
          [...Array(emptyStars)].map((_, i) => <StarBorder key={i} color="#7CA324" size={20} />)}
      </span>
      <span className="small-rating-text">
        {translate('ratingBox.tooltip', {
          rating: (Math.round(ratingToUse.rating * 100) / 100).toFixed(1),
          total: ratingToUse.user_ratings_total,
        })}{' '}
        {translate('ratingBox.source', { source: isGolfhaftet ? 'Golfamore' : 'Google' })}
      </span>
    </div>
  );
};

export default RatingBox;
